import apiClient from "../apiClient";

const resource = "attendanceDevices";

export default {
    getAll: () => apiClient.get(`${resource}`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    add: payload => apiClient.post(`${resource}`, payload),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    delete: id => apiClient.delete(`${resource}/${id}`),
    getSyncRuns: id => apiClient.get(`${resource}/${id}/sync-runs`),

    getMappings: params => apiClient.get(`${resource}/mappings?${params}`),
    getUnmapped: () => apiClient.get(`${resource}/unmapped`),
    addMapping: payload => apiClient.post(`${resource}/mappings`, payload),
    deleteMapping: id => apiClient.delete(`${resource}/mappings/${id}`),

    getPunches: params => apiClient.get(`${resource}/punches?${params}`),
};
